import usePrivateAxios from "@/common/api/usePrivateAxios"
import { ErrorResponse } from "@/common/types/errorResponse";
import { CompanyValidationSchema } from "@/features/privateCompanies/schemas/create.schema"
import { useMutation } from "@tanstack/react-query"
import { AxiosResponse } from "axios";

interface UseUpdateCompany {
  companyId?: string,
  onSuccess?: (response: AxiosResponse) => void,
  onError?: (error: ErrorResponse) => void,
}

const useUpdateCompany = ({
  companyId,
  onSuccess,
  onError,
}: UseUpdateCompany) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['updateCompany'],
    mutationFn: async (form: CompanyValidationSchema) => {
      const payload = {
        ...form,
        commercial_manager_id: form.commercial_manager?.value,
        commercial_manager_substitute_id: form.commercial_manager_substitute?.value || null,
        time_zone_id: form.time_zone_id?.value,
      }

      return privateAxios.put(`/client/companies/${companyId}`, { company: payload })
    },
    onSuccess,
    onError,
  })
}

export default useUpdateCompany
